export const BUTTON_ACTION_RIBBON = 'ButtonActionRibbon';
export const BUTTON_ACTION_RIBBON_MENU = 'ButtonActionRibbonMenu';
export const BUTTON_ACTION_RIBBON_SPLIT = 'ButtonActionRibbonSplit';
